module.exports = __webpack_public_path__ + "img/yjal.8b69b959.png";